<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button icon="sync" @click="apiOrderdetailsQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="订单详情查询">
				<div class="qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">服务商：</div>
						<a-select v-model="query.facilitatorId" placeholder="请选择服务商">
							<a-select-option v-for="(item, index) in facilitatorList" :key="index" :value="item.facilitatorId">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</div>
			
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">门票名称：</div>
						<a-input placeholder="请输入门票名称：" v-model="query.productName"  />
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">人群：</div>
						<a-input placeholder="请输入人群种类" v-model="query.crowdtypeName"  />
					</div>
				</div>
				<div class="qinang-margin-top-12 qinang-search-row">
					
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">订单编号：</div>
						<a-input placeholder="请输入订单编号" v-model="query.ordersNumber"  />
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">票号：</div>
						<a-input placeholder="请输入票号" v-model="query.ticketNumber"  />
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">渠道单号：</div>
						<a-input placeholder="请输入渠道单号" v-model="query.outTicketNumber"  />
					</div>
				</div>
				<div class="qinang-margin-top-12 qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">游客姓名：</div>
						<a-input placeholder="请输入游客姓名" v-model="query.touristName"  />
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">游客手机号：</div>
						<a-input placeholder="请输入游客手机号" v-model="query.touristTel"  />
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">游客证件号：</div>
						<a-input placeholder="请输入游客身份证号" v-model="query.touristCard"  />
					</div>
				</div>
				<div class="qinang-margin-top-12 qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">购票日期：</div>
						<a-date-picker v-model="query.startTime" format="YYYY-MM-DD" class="qinang-search-time-picker-2" />
						<span style="width: 20px;text-align: center;">-</span>
						<a-date-picker class="qinang-search-time-picker-2" v-model="query.endTime" format="YYYY-MM-DD" />
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">订单状态：</div>
						<a-select v-model="query.orderdetailsState" placeholder="请选择订单状态">
							<a-select-option v-for="(item, index) in orderState" :key="index" :value="item.vlaue">{{item.label}}</a-select-option>
						</a-select>
					</div>
					<div class="qinang-search-col-3">
						<a-button type="primary" icon="search" @click="apiOrderdetailsQueryList">查询</a-button>
						<a-button icon="redo" @click="resetQuery" style="margin-left: 14px;">重置</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<a-table :columns="tableColumns" :data-source="tableData" row-key="ordersNumber" :loading="tableLoading" :pagination="false" :scroll="{ x: 1300 }">
				<span slot="productName" slot-scope="productName">
					{{productName.productName +'('+ productName.crowdtypeName +')'}}
				</span>
				<span slot="facilitatorId" slot-scope="facilitatorId">
					{{facilitatorList.find(item => item.facilitatorId === facilitatorId.facilitatorId)?.facilitatorName || ''}}
				</span>
				<span slot="staffId" slot-scope="staffId">
					{{staffList.find(item => item.staffId === staffId.staffId)?.staffName || ''}}
				</span>
				<span slot="createTime" slot-scope="createTime">
					{{qaUtil.timeFormat(createTime.createTime)}}
				</span>
				
				<span slot="tableAction" slot-scope="tableAction">
					<a-button type="link" @click="OrderDetails(tableAction)" >详情</a-button>
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>
		<a-modal  class="qa-modal" width="100%"  title="订单详情" :visible="detailsVisible" :footer="null" @ok="detailsVisible=false" @cancel="detailsVisible=false" :maskClosable="false" :keyboard="false">
			<OrderInfo v-if="detailsVisible" :ordersNumber="ordersNumber" :refundState="true"></OrderInfo>
		</a-modal>


		
	</div>
</template>

<script>
	import moment from 'moment'
	import OrderInfo from './OrderInfo.vue';
	export default {
		components: {
			OrderInfo,
		},
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				detailsVisible:false,
				ordersNumber:undefined,
				facilitatorList: [],//服务商列表
				checkstationList:[],//园门
				checkdeviceList:[],//设备
				staffList:[],//售票员
				orderState:[
					{
						label: '已退票',
						value: 2
					},
					{
						label: '未使用',
						value: 3
					},
					{
						label: '全部使用',
						value: 4
					},
					{
						label: '部分检票',
						value: 5
					},
					{
						label: '未支付',
						value: 6
					},
				],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: undefined,
					startTime: undefined,
					endTime: undefined,
					ordersNumber: undefined,
					ticketNumber:undefined,
					outTicketNumber:undefined,
					touristName:undefined,
					touristTel:undefined,
					touristCard:undefined,

					

				},
	
				tableData: [],
				tableColumns: [
					{
						title: '订单编号',
						dataIndex: 'ordersNumber',
						key: 'ordersNumber',
						align: 'center',
						width: 150,
						fixed: 'left' 
					},
					{
						title: '票号',
						dataIndex: 'ticketNumber',
						key: 'ticketNumber',
						width: 150,
						align: 'center',
					},
					{
						title: '渠道单号',
						dataIndex: 'outTicketNumber',
						key: 'outTicketNumber',
						width: 150,
						align: 'center',
					},
					{
						title: '服务商',
						key: 'facilitatorId',
						width: 250,
						align: 'center',
						scopedSlots: {
							customRender: 'facilitatorId'
						}
					},
					{
						title: '售票',
						key: 'staffId',
						width: 150,
						align: 'center',
						scopedSlots: {
							customRender: 'staffId'
						}
					},
					{
						title: '门票名称',
						key: 'productName',
						width: 300,
						align: 'center',
						scopedSlots: {
							customRender: 'productName'
						}
					},
					{
						title: '购票时间',
						key: 'createTime',
						width: 150,
						align: 'center',
						scopedSlots: {
							customRender: 'createTime'
						}
					},
					{
						title: '游客电话号',
						dataIndex: 'touristTel',
						key: 'touristTel',
						width: 150,
						align: 'center',
					},
					{
						title: '游客姓名',
						dataIndex: 'touristName',
						key: 'touristName',
						width: 120,
						align: 'center',
					},
					{
						title: '游客证件号',
						dataIndex: 'touristCard',
						key: 'touristCard',
						width: 200,
						align: 'center',
					},
					{
						title: '操作',
						key: 'tableAction',
						align: 'center',
						width: 150,
						fixed: 'right', 
						scopedSlots: {
							customRender: 'tableAction'
						}
					},

				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
		
			};
		},
		methods: {
			async apiFacilitatorListForStaff() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorListForStaff, {staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.facilitatorList = res.data
				} else {

				}
			},

			async apiCheckstationList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCheckstationList, {facilitatorId:this.query.facilitatorId});
				if (res.code == 200) {
					this.checkstationList = res.data
				} else {
			
				}
			},

			async apiStaffList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiStaffAll, {staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.staffList = res.data
				} else {
			
				}
			},

			async apiOrderdetailsQueryList() {
				let queryData = this.query
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiOrderdetailsQueryList, queryData);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiOrderdetailsQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiOrderdetailsQueryList()
			},
			resetQuery(){
				this.query = {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: undefined,
					startTime: undefined,
					endTime: undefined,
					ordersNumber: undefined,
					ticketNumber:undefined,
					outTicketNumber:undefined,
					touristName:undefined,
					touristTel:undefined,
					touristCard:undefined,
				}
				this.apiOrderdetailsQueryList()
			},

			
			tableSee() {
				if(this.tableSelectedRows.dutyId > 0) {
					// this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
			OrderDetails(item) {
				this.ordersNumber = item.ordersNumber
				this.detailsVisible = true
			},
			
		},
		computed: {
			
		},
		created() {
			this.apiFacilitatorListForStaff()
			this.apiOrderdetailsQueryList()
			this.apiStaffList()
		}
	};
</script>

<style scoped>
	

</style>
